<template>
    <div class='new_house'>
        <!-- v-wechat-title="title"-->
        <div class="content">
            <div class="search_box" @keyup="keyUp($event)" @click="searchKey()">
                <el-input placeholder="请输入房型、地址、小区搜索" v-model="select.keyword"
                          class="input-with-select">
                    <el-button slot="append">搜索</el-button>
                </el-input>
            </div>
            <div class="site" v-for="(item,index) in screenData" :key="index">
                <span class="title">{{ item.name}}：</span>
                <div>
                    <ul class="site_list">
                        <li v-for="(items,indexs) in item.value_list" :key="indexs" @click='change(item,items,indexs)'
                            :class="{active: selectId.indexOf(item.id + ':' + items.id) !== -1}"
                            v-if="items.name !== ''">
                            {{ items.name }}
                        </li>
                    </ul>
                    <ul class="site_list" v-for="(tab,tabs) in item.value_list" :key="tabs">
                        <li v-for="(itemss,indexss) in etityList" :key="indexss" @click='change(item,itemss,indexss)'
                            :class="{active: selectId.indexOf(item.id + ':' + itemss.id) !== -1}"
                            v-if="itemss.name !== '' && tab.id === itemss.pid">
                            <!--<span v-show="items.pid === 0">-->
                            {{ itemss.name }}
                            <!--</span>-->
                        </li>
                    </ul>
                </div>
            </div>
            <div class="total">共 <span>{{ totalNum }}</span> 套房源</div>
            <ul class='list'>
                <li v-for='item in newHouseList' :key='item.id' @click="toDetails(item.id)">
                    <!--@click="$router.push(`/newHouse/newDetails/${item.id}`)">-->

                    <div class="imgs">
                        <img :src='item.缩略图'>
                    </div>
                    <div class='details'>
                        <span v-text='item.楼盘名称'></span>
                        <div>均价：{{ item.均价 }}元/平米</div>
                        <!--<div>用途：{{ item.用途 }}</div>-->
                        <div>面积：{{ item.面积 }}平米</div>
                        <div>地址：{{ item.地址 }}</div>
                    </div>
                </li>
            </ul>
            <div class="haveMore" v-show="totalNum === 0" style="text-align: center"></div>
            <el-pagination
                    layout="total,prev, pager, next"
                    :current-page.sync="select.page"
                    :page-size='select.limit'
                    @current-change="handleCurrentChange"
                    :total="totalNum">
            </el-pagination>
        </div>
    </div>
</template>
<script>
	import Header from "../../components/nav.vue";
	import {getRegionList, getEntityList, screenField, getObjectList, search} from '../../api/index.js'

	export default {
		data() {
			return {
				title: '',
				index_logo: '',
				newHouseList: [],//房源列表
				//返回图片为空时默认图片
				// imgerrorfun: 'this.src="' + require('../assets/new-details/img_xfxiangqing_banner.png') + '"',
				blocks: [],
				regions: [],
				selectRegion: false,
				curPrice: '',// 价格
				curArea: '',// 面积
				// select: {
				// 	page: 1,
				// 	limit: 15,
				// 	keyword: "",
				// 	domain_id: "",// 位置
				// 	price_low: "",
				// 	price_high: "",
				// 	acreage_low: "",
				// 	acreage_high: "",
				// 	orde: "",//排序
				// 	orde_type: "",
				// 	purpose: ''
				// },
				select_id: '',
				totalNum: 0,
				price: '',
				upload: false,
				showSearch: false,
				isChoose: false,
				select: {
					page: 1,
					limit: 15,
					object_type: '新房',
					condition: '',
					keyword: "",
				},
				screenData: '',//筛选数据
				isShowPid: false,
				entity: {
					entity_id: '',
					pid: ''
				},
				etityList: '',
				screenDataID: [],//选中区域、收藏、交易
				selectId: [],////选中区域id、收藏id、交易id
				message: ''
			}
		},

		components: {
			// "v-footer": Footer,
			"v-header": Header,
		},
		created() {
			this.index_logo = localStorage.getItem('index_logo')
		},
		mounted() {
			// window.addEventListener('scroll', this.handleScroll);
			this.init();
			this.region();
			this.getScreenField()
		},
		methods: {
			change(item, items) {
				// console.log(item, items, indexs)
				// console.log(this.screenDataID.indexOf(item.id))
				let SubArry = '';
				let screen = item.id + ':' + items.id
				if (this.screenDataID.indexOf(item.id) === -1) {
					this.screenDataID.push(item.id)
					// this.select_id = items.id
					this.selectId.push(screen)
					for (let j = 0; j < this.selectId.length; j++) {
						// console.log(this.selectId[j])
						SubArry += this.selectId[j] + '#'
					}
					this.select.condition = SubArry.slice(0, -1)
					// console.log(this.select.condition)
					if (items.pid === 0) {
						this.isShowPid = true
						this.entity.pid = items.id
						this.entity.entity_id = items.entity_id
						this.getEntity()
					}
					this.init()
				} else {
					for (let i = 0; i < this.screenDataID.length; i++) {
						if (this.screenDataID[i] === item.id) {
							for (let k = 0; k < this.selectId.length; k++) {
								// console.log(0)
								let obj = this.selectId[k].split(':')[0]
								if (obj === item.id) {
									// console.log(items.pid )
									if (items.pid === undefined) {
										if (this.selectId[k] === screen) {
											// console.log(20)
											this.selectId.splice(k, 1)
											this.screenDataID.splice(i, 1)
										} else {
											// console.log(21)
											this.selectId.splice(k, 1)
											this.selectId.push(screen)
										}
									} else {
										if (this.selectId[k] === screen) {
											// console.log(10)
											this.selectId.splice(k, 1)
											this.screenDataID.splice(i, 1)
											this.ind = 0
											this.entity.pid = ''
											this.entity.entity_id = ''
											this.getEntity()
										} else {
											this.selectId.splice(k, 1)
											this.selectId.push(screen)
											if (items.pid === 0) {
												// console.log(12)
												this.entity.pid = items.id
												this.entity.entity_id = items.entity_id
												this.getEntity()
											}
										}
									}
									if (this.selectId.length === 0) {
										this.select.condition = ''
									} else {
										for (let y = 0; y < this.selectId.length; y++) {
											// console.log(this.selectId[y])
											SubArry += this.selectId[y] + '#'
										}
										this.select.condition = SubArry.slice(0, -1)
									}
									this.init()
								}
							}
						}
					}
				}
				// console.log(this.screenDataID)
				// console.log(this.selectId)
				// console.log(this.select.condition)
			},
			getEntity() {
				getEntityList(
					this.entity
				).then(res => {
					// console.log(res)
					this.etityList = res.data;
				}).catch(err => {
					this.$message({
						message: err.msg,
						type: 'warning'
					});
				})
			},
			//房屋筛选条件
			getScreenField() {
				let _this = this
				screenField({
					object_type: this.select.object_type
				}).then(res => {
					// console.log(res)
					_this.screenData = res.data;
				}).catch(err => {
					this.$message({
						message: err.msg,
						type: 'warning'
					});
				})
			},
			init() {
				console.log(localStorage.getItem('meta_title'))
				// this.title = '新房 ' + localStorage.getItem('meta_title')
				let _this = this
				console.log(this.$route.query.keyword, this.select.keyword)
				if (_this.$route.query.keyword === undefined && this.select.keyword === '') {
					getObjectList(
						this.select
					).then(res => {
						console.log(res)
						if (res.count === 0) {
							this.$message({
								message: '敬请期待！',
								duration: 1500,
								type: 'warning'
							});
							document.querySelector(".haveMore").innerHTML = '敬请期待';
						}
						_this.newHouseList = res.data;
						_this.totalNum = res.count
					}).catch(err => {
						this.$message({
							message: err.msg,
							type: 'warning'
						});
					})
				} else {
					if (this.$route.query.keyword !== undefined) {
						this.select.keyword = this.$route.query.keyword
					}
					search(
						this.select
					).then(res => {
						console.log(res)
						if (res.count === 0) {
							this.$message({
								message: '敬请期待！',
								duration: 1500,
								type: 'warning'
							});
							document.querySelector(".haveMore").innerHTML = '敬请期待';
						}
						this.newHouseList = res.data
						this.totalNum = res.count;
					}).catch(err => {
						this.$message({
							message: err.msg,
							type: 'warning'
						})
					})
				}
			},

			//获取县/区列表
			region() {
				getRegionList({
					pid: 0
				}).then(res => {
					// console.log(res.data)
					this.regions = res.data
				}).catch(err => {
					this.$message({
						message: err.msg,
						type: 'warning'
					});
				})
			},
			keyUp(event) {
				// console.log(event.keyCode)
				if (event.keyCode == 13) {
					// 调用登录按钮或者登录方法
					this.searchKey()
				}
			},
			searchKey() {
				this.init()
			},
			//点击跳转到性情
			toDetails(id) {
				this.$router.push({path: '/newDetail/' + id});
			},
			// handleScroll() {
			// 	let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			// 	// console.log(scrollTop)
			// 	if (scrollTop > 195) {
			// 		this.isChoose = true
			// 		this.showSearch = true
			// 	} else {
			// 		this.isChoose = false
			// 		this.showSearch = false
			// 	}
			// },
			// 分页
			handleCurrentChange(val) {
				let _this = this;
				// 记录当前page的值
				this.select.page = val;
				_this.newHouseList = [];
				let pms = {
					limit: this.select.limit
				};
				if (val >= 1) {
					Object.assign(pms, {page: val})
				}
				getObjectList(
					this.select
				).then(res => {
					_this.newHouseList = res.data;
					_this.totalNum = res.count
				}).catch(err => {
					this.$message({
						message: err.msg,
						type: 'warning'
					})
				})
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
			}
		},
		computed: {
			// state: function () {
			// 	return this.$store.state.newHouse;
			// },
			// config() {
			// 	return this.$store.state.config;
			// }
		},
		destroyed() {
			// window.removeEventListener('scroll', this.handleScroll)
		}
	}
</script>
<style lang="less" rel="stylesheet/less" scoped>
    @import "new";

</style>


